// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginForm_root__22FuC","form":"LoginForm_form__1DPxB","button":"LoginForm_button__1B_Kr"};